import { Url } from "url";
import { AppDesign, UpdateAppDesignColor, UpdateAppDesignLogo } from "../types/configurationType";
import {CallResult, doApiGet, doApiPatch, doApiPatchFormData} from "./Requests";

export const configurationApi = {
  getAppDesign: (): Promise<CallResult<Partial<AppDesign>>> =>
    doApiGet(`/api/companies/current/customizations`),

  updateAppDesignColor: (payload: UpdateAppDesignColor): Promise<CallResult<any>> =>
    doApiPatch(`/api/companies/current/customizations/color`, payload),

  updateAppDesignLogo: (file: File | null): Promise<CallResult<string>> => {
    const formData = new FormData();
    if (file) formData.append("file", file);
    return doApiPatchFormData(`/api/companies/current/customizations/logo`, formData);
  },
};